/* BD49 Laserschutzbrillen-Finder – Logik (frameworkfrei, Liquid-unabhaengig) */
(function(){
  function initOne(root){
    if(root.__bd49Init) return; root.__bd49Init=true;
    var MODE=root.dataset.mode||'full';
    var LIMIT=9;
    var DATA=null;
    var CROSS=null;

    var elResultwrap=root.querySelector('[data-bd49-resultwrap]');
    var elTitle=root.querySelector('[data-bd49-result-title]');
    var elResults=root.querySelector('[data-bd49-results]');
    var elMoreWrap=root.querySelector('[data-bd49-morewrap]');
    var elMore=root.querySelector('[data-bd49-more]');
    var elCross=root.querySelector('[data-bd49-cross]');
    var elCrossRow=root.querySelector('[data-bd49-cross-row]');
    var elSafetyNote=root.querySelector('[data-bd49-safety-note]');
    var elRechner=root.querySelector('[data-bd49-rechner]');
    var elEmpty=root.querySelector('[data-bd49-empty]');

    function esc(s){var d=document.createElement('div');d.textContent=(s==null?'':s);return d.innerHTML;}
    function eur(v){var n=parseFloat(v);if(isNaN(n))return '';return n.toLocaleString('de-DE',{minimumFractionDigits:2,maximumFractionDigits:2})+' €';}
    function clusterById(id){return (DATA.clusters||[]).filter(function(c){return c.id===id;})[0];}
    function humanize(h){
      return (h||'').split('-').map(function(w){
        if(/^en$/i.test(w))return 'EN';
        if(/^\d+k$/i.test(w))return w.toUpperCase();
        if(/^od\d*$/i.test(w))return w.toUpperCase();
        if(!w)return w;
        return w.charAt(0).toUpperCase()+w.slice(1);
      }).join(' ');
    }
    function relevantBands(glass, cluster){
      if(!cluster||!cluster.nm) return glass.bands||[];
      var lo=cluster.nm[0], hi=cluster.nm[1];
      return (glass.bands||[]).filter(function(b){ return b.start<=hi && b.end>=lo; });
    }
    function maxOd(glass, cluster){
      var b=relevantBands(glass,cluster), m=0;
      b.forEach(function(x){ if((x.od||0)>m) m=x.od; });
      return m;
    }
    function glassesForCluster(id){
      return (DATA.glasses||[]).filter(function(g){ return (g.clusters||[]).indexOf(id)>-1; });
    }
    function safetyBlock(){
      elSafetyNote.textContent=(DATA.meta&&DATA.meta.safety_note)||'';
      if(DATA.meta&&DATA.meta.rechner_url){ elRechner.setAttribute('href',DATA.meta.rechner_url); }
    }
    function bandRow(b){
      var pre=b.gt?'>':'';
      var nm=pre+b.start+'–'+b.end+' nm';
      return '<div class="bd49-band"><span class="bd49-band-nm">'+esc(nm)+'</span>'+
             '<span class="bd49-band-lb">'+esc(b.code)+'</span></div>';
    }
    function cardHTML(g, cluster){
      var bands=relevantBands(g,cluster);
      var bandsHTML=bands.length? bands.map(bandRow).join('') :
        '<div class="bd49-band"><span class="bd49-band-nm">'+esc(cluster.nm[0]+'–'+cluster.nm[1]+' nm')+'</span><span class="bd49-band-lb">zertifiziert</span></div>';
      var specs='';
      if(g.filter) specs+='<span>Filter: '+esc(g.filter)+'</span>';
      if(g.vlt) specs+='<span>VLT: '+esc(g.vlt)+'</span>';
      var img=g.image? '<div class="bd49-card-img"><img src="'+esc(g.image)+'" alt="'+esc(g.title)+'" loading="lazy"></div>':'';
      return '<article class="bd49-card">'+
        img+
        '<h4 class="bd49-card-title">'+esc(g.title)+'</h4>'+
        (specs?'<div class="bd49-card-specs">'+specs+'</div>':'')+
        '<div class="bd49-bands"><p class="bd49-bands-h">Zertifizierte Schutzstufe im Bereich</p>'+bandsHTML+'</div>'+
        '<div class="bd49-card-price">'+esc(eur(g.price_netto))+'<small>Nettopreis zzgl. MwSt.</small></div>'+
        '<div class="bd49-card-cta"><a class="bd27-btn bd27-btn--red" href="'+esc(g.url||('/products/'+g.handle))+'">Ansehen</a></div>'+
        '</article>';
    }
    function crossItemsFor(clusterId){
      var enriched=(CROSS&&CROSS[clusterId])||null;
      if(enriched&&enriched.length) return enriched;
      var handles=(DATA.crosssell&&DATA.crosssell[clusterId])||[];
      return handles.map(function(h){ return {handle:h,title:humanize(h),url:'/products/'+h,image:null}; });
    }
    function crossTileHTML(it){
      var handle=it.handle||'';
      var url=it.url||('/products/'+handle);
      var title=it.title||humanize(handle);
      var img=it.image
        ? '<span class="bd49-cross-img"><img src="'+esc(it.image)+'" alt="'+esc(title)+'" loading="lazy"></span>'
        : '<span class="bd49-cross-img bd49-cross-img--ph" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M4 5h16v14H4z"/><path d="M4 15l4-4 4 4 3-3 5 5"/><circle cx="9" cy="9" r="1.4"/></svg></span>';
      var priceHTML=(it.price_netto!=null&&it.price_netto!=='')
        ? '<span class="bd49-cross-price">'+esc(eur(it.price_netto))+'<small>Nettopreis zzgl. MwSt.</small></span>'
        : '';
      return '<a class="bd49-cross-tile" href="'+esc(url)+'">'+img+
        '<span class="bd49-cross-info"><span class="bd49-cross-title">'+esc(title)+'</span>'+priceHTML+'</span></a>';
    }
    function renderCross(clusterId){
      var list=crossItemsFor(clusterId);
      if(!list.length){ elCross.hidden=true; elCrossRow.innerHTML=''; return; }
      elCrossRow.innerHTML=list.map(crossTileHTML).join('');
      elCross.hidden=false;
    }
    function render(clusterId, deviceTitle){
      var cluster=clusterById(clusterId);
      if(!cluster) return;
      safetyBlock();
      var list=glassesForCluster(clusterId);
      list.sort(function(a,b){ return maxOd(b,cluster)-maxOd(a,cluster); });
      var titleTxt='Für '+cluster.label+' zertifizierte Schutzbrillen';
      if(deviceTitle) titleTxt+=' · Gerät: '+deviceTitle;
      elTitle.textContent=titleTxt;
      elResults.innerHTML=list.slice(0,LIMIT).map(function(g){return cardHTML(g,cluster);}).join('');
      if(list.length>LIMIT){
        elMore.textContent='Alle '+list.length+' Schutzbrillen ansehen';
        elMoreWrap.hidden=false;
      } else { elMoreWrap.hidden=true; }
      renderCross(clusterId);
      elResultwrap.hidden=false;
      if(elEmpty) elEmpty.hidden=true;
    }
    function activateTab(name){
      root.querySelectorAll('[data-bd49-tab]').forEach(function(t){ t.classList.toggle('is--active',t.dataset.bd49Tab===name); });
      root.querySelectorAll('[data-bd49-entry]').forEach(function(e){ e.hidden = e.dataset.bd49Entry!==name; });
    }
    function fillDevices(){
      var sel=root.querySelector('[data-bd49-device]');
      if(!sel) return;
      (DATA.devices||[]).slice().sort(function(a,b){return (a.title||'').localeCompare(b.title||'','de');}).forEach(function(d){
        var o=document.createElement('option');
        o.value=d.handle; o.textContent=d.title;
        o.setAttribute('data-cluster',d.cluster_id);
        sel.appendChild(o);
      });
      sel.addEventListener('change',function(){
        var opt=sel.options[sel.selectedIndex];
        if(!sel.value){ elResultwrap.hidden=true; if(elEmpty) elEmpty.hidden=false; return; }
        LIMIT=9;
        render(opt.getAttribute('data-cluster'), opt.textContent);
      });
    }
    function fillClusters(){
      var wrap=root.querySelector('[data-bd49-clusters]');
      if(!wrap) return;
      wrap.innerHTML=(DATA.clusters||[]).map(function(c){
        var short=c.aliases&&c.aliases.length? c.aliases[0] : (c.nm?c.nm[0]+'–'+c.nm[1]+' nm':'');
        return '<button type="button" class="bd49-chip" data-cid="'+esc(c.id)+'"><b>'+esc(c.label)+'</b><small>'+esc(short)+'</small></button>';
      }).join('');
      wrap.querySelectorAll('[data-cid]').forEach(function(btn){
        btn.addEventListener('click',function(){
          wrap.querySelectorAll('[data-cid]').forEach(function(b){b.classList.toggle('is--active',b===btn);});
          LIMIT=9;
          render(btn.dataset.cid,null);
        });
      });
    }
    function initFull(){
      fillDevices();
      fillClusters();
      var entry=root.dataset.defaultEntry||'geraet';
      activateTab(entry);
      root.querySelectorAll('[data-bd49-tab]').forEach(function(t){
        t.addEventListener('click',function(){ activateTab(t.dataset.bd49Tab); });
      });
      var preset=root.dataset.presetCluster;
      if(preset && clusterById(preset)){
        activateTab('anwendung');
        var pb=root.querySelector('[data-cid="'+preset+'"]');
        if(pb){ pb.classList.add('is--active'); render(preset,null); }
      } else if(elEmpty){ elEmpty.hidden=false; }
    }
    function initAuto(){
      var handle=root.dataset.productHandle||'';
      var dev=(DATA.devices||[]).filter(function(d){return d.handle===handle;})[0];
      if(!dev){ root.parentNode&&root.remove(); return; }
      root.style.display='';
      LIMIT=9;
      render(dev.cluster_id, null);
    }
    function crossSrc(){
      var s=root.dataset.crossSrc;
      if(s) return s;
      var base=root.dataset.src||'';
      return base.indexOf('bd-brillenfinder-data')>-1
        ? base.replace('bd-brillenfinder-data','bd-brillenfinder-crosssell')
        : '';
    }
    fetch(root.dataset.src).then(function(r){return r.json();}).then(function(j){
      DATA=j;
      var cs=crossSrc();
      var p=cs? fetch(cs).then(function(r){return r.ok?r.json():null;}).catch(function(){return null;}) : Promise.resolve(null);
      return p.then(function(cj){
        CROSS=cj||null;
        if(MODE==='auto'){ initAuto(); } else { initFull(); }
      });
    }).catch(function(e){
      if(MODE==='auto'){ root.parentNode&&root.remove(); }
      else { if(elEmpty){ elEmpty.hidden=false; elEmpty.textContent='Der Schutzbrillen-Finder konnte nicht geladen werden. Bitte kontaktieren Sie uns: +49 2383 6590790.'; } }
    });
  }
  function boot(){ document.querySelectorAll('.bd49').forEach(initOne); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',boot); } else { boot(); }
})();
